import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ActiveConsultantOption {
  id: string;
  full_name: string;
}

export const useActiveConsultantsForRedistribution = (enabled = true) => {
  return useQuery({
    queryKey: ['active-consultants-for-redistribution'],
    enabled,
    queryFn: async (): Promise<ActiveConsultantOption[]> => {
      const { data, error } = await supabase.rpc('list_active_consultants_for_redistribution');
      if (error) throw error;
      return (data ?? []) as ActiveConsultantOption[];
    },
  });
};
